<ng-container *ngIf="teamType === lastMatchTeams.Home">
    <div class="home-result-container" *ngIf="lastEventsStatistics">
        <div class="home-result-event-container" *ngFor="let lastEvent of lastEventsStatistics.home.slice().reverse()">
            <div class="result-container">
                <div class="result result-{{ lastEvent.fixtureOutcome | lowercase }}">
                    <div class="value">{{ $any(sitecore.statistics)[lastEvent.fixtureOutcome + 'Abr'] }}</div>
                </div>
                <div class="horizontal-line"></div>
            </div>
            <div class="date" *ngIf="showEventDates && lastEvent.dateOfEvent">{{ lastEvent.dateOfEvent | date: 'dd/MM' }}</div>
        </div>
        <div>
            <div class="triangle-home"></div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="teamType === lastMatchTeams.Away">
    <div class="away-result-container" *ngIf="lastEventsStatistics">
        <div>
            <div class="triangle-away"></div>
        </div>
        <div class="away-result-event-container" *ngFor="let lastEvent of lastEventsStatistics.away.slice().reverse()">
            <div class="result-container">
                <div class="horizontal-line"></div>
                <div class="result result-{{ lastEvent.fixtureOutcome | lowercase }}">
                    <div class="value">{{ $any(sitecore.statistics)[lastEvent.fixtureOutcome + 'Abr'] }}</div>
                </div>
            </div>
            <div class="date" *ngIf="showEventDates && lastEvent.dateOfEvent">{{ lastEvent.dateOfEvent | date: 'dd/MM' }}</div>
        </div>
    </div>
</ng-container>
